module.exports = __webpack_public_path__ + "static/media/Slider 2 1.bc0075d0.jpg";